
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {FeedSubscribeResponse} from './FeedSubscribeResponse';

/**
 * FeedSubscribeRequest struct
 */
class FeedSubscribeRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!Map=} symbolIdsWithLevels
   * @param {!Map=} symbolNamesWithLevels
   * @constructor
   */
  constructor (parent = new Request(), symbolIdsWithLevels = new Map(), symbolNamesWithLevels = new Map()) {
    super()
    super.copy(parent)
    this.SymbolIdsWithLevels = symbolIdsWithLevels
    this.SymbolNamesWithLevels = symbolNamesWithLevels
  }

  /**
   * Copy struct (shallow copy)
   * @this {!FeedSubscribeRequest}
   * @param {!FeedSubscribeRequest} other Other struct
   * @returns {!FeedSubscribeRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.SymbolIdsWithLevels != null) {
      this.SymbolIdsWithLevels = new Map()
      Object.keys(other.SymbolIdsWithLevels).forEach(key => {
        if (key != null) {
          let tempKey
          tempKey = new UUID(key)
          if (other.SymbolIdsWithLevels[key] != null) {
            let tempValue
            tempValue = other.SymbolIdsWithLevels[key]
            this.SymbolIdsWithLevels.set(tempKey, tempValue)
          } else {
            this.SymbolIdsWithLevels.set(tempKey, null)
          }
        }
      })
    } else {
      this.SymbolIdsWithLevels = null
    }
    if (other.SymbolNamesWithLevels != null) {
      this.SymbolNamesWithLevels = new Map()
      Object.keys(other.SymbolNamesWithLevels).forEach(key => {
        if (key != null) {
          let tempKey
          tempKey = key
          if (other.SymbolNamesWithLevels[key] != null) {
            let tempValue
            tempValue = other.SymbolNamesWithLevels[key]
            this.SymbolNamesWithLevels.set(tempKey, tempValue)
          } else {
            this.SymbolNamesWithLevels.set(tempKey, null)
          }
        }
      })
    } else {
      this.SymbolNamesWithLevels = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!FeedSubscribeRequest}
   * @returns {!FeedSubscribeRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new FeedSubscribeRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new FeedSubscribeRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!FeedSubscribeRequest}
   * @param {!FeedSubscribeRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof FeedSubscribeRequest)) {
      throw new TypeError('Instance of FeedSubscribeRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!FeedSubscribeRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      SymbolIdsWithLevels: ((this.SymbolIdsWithLevels != null) ? fbe.MapToObject(new Map(Array.from(this.SymbolIdsWithLevels, item => [((item[0] != null) ? item[0].toString() : null), ((item[1] != null) ? item[1] : null)]))) : null),
      SymbolNamesWithLevels: ((this.SymbolNamesWithLevels != null) ? fbe.MapToObject(new Map(Array.from(this.SymbolNamesWithLevels, item => [((item[0] != null) ? item[0] : null), ((item[1] != null) ? item[1] : null)]))) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return FeedSubscribeRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!FeedSubscribeRequest} other Object value
   * @returns {!FeedSubscribeRequest} Created struct
   */
  static fromObject (other) {
    return new FeedSubscribeRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!FeedSubscribeRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return FeedSubscribeRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!FeedSubscribeRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 2038
  }
}

export { FeedSubscribeRequest };

/**
 * Fast Binary Encoding FeedSubscribeRequest field model
 */
class FieldModelFeedSubscribeRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.SymbolIdsWithLevels = new fbe.FieldModelMap(new fbe.FieldModelUUID(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), new fbe.FieldModelUInt16(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.SymbolNamesWithLevels = new fbe.FieldModelMap(new fbe.FieldModelString(buffer, this.SymbolIdsWithLevels.fbeOffset + this.SymbolIdsWithLevels.fbeSize), new fbe.FieldModelUInt16(buffer, this.SymbolIdsWithLevels.fbeOffset + this.SymbolIdsWithLevels.fbeSize), buffer, this.SymbolIdsWithLevels.fbeOffset + this.SymbolIdsWithLevels.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelFeedSubscribeRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelFeedSubscribeRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelFeedSubscribeRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.SymbolIdsWithLevels.fbeSize + this.SymbolNamesWithLevels.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelFeedSubscribeRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.SymbolIdsWithLevels.fbeExtra + this.SymbolNamesWithLevels.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelFeedSubscribeRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelFeedSubscribeRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelFeedSubscribeRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 2038
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelFeedSubscribeRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelFeedSubscribeRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SymbolIdsWithLevels.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolIdsWithLevels.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolIdsWithLevels.fbeSize

    if ((fbeCurrentSize + this.SymbolNamesWithLevels.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.SymbolNamesWithLevels.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolNamesWithLevels.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelFeedSubscribeRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelFeedSubscribeRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelFeedSubscribeRequest}
   * @param {!FeedSubscribeRequest} fbeValue Default value, defaults is new FeedSubscribeRequest()
   * @returns {!FeedSubscribeRequest} FeedSubscribeRequest value
   */
  get (fbeValue = new FeedSubscribeRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelFeedSubscribeRequest}
   * @param {!FeedSubscribeRequest} fbeValue FeedSubscribeRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.SymbolIdsWithLevels.fbeSize) <= fbeStructSize) {
      this.SymbolIdsWithLevels.get(fbeValue.SymbolIdsWithLevels)
    } else {
      fbeValue.SymbolIdsWithLevels.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolIdsWithLevels.fbeSize

    if ((fbeCurrentSize + this.SymbolNamesWithLevels.fbeSize) <= fbeStructSize) {
      this.SymbolNamesWithLevels.get(fbeValue.SymbolNamesWithLevels)
    } else {
      fbeValue.SymbolNamesWithLevels.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.SymbolNamesWithLevels.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelFeedSubscribeRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelFeedSubscribeRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelFeedSubscribeRequest}
   * @param {!FeedSubscribeRequest} fbeValue FeedSubscribeRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelFeedSubscribeRequest}
   * @param {FeedSubscribeRequest} fbeValue FeedSubscribeRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.SymbolIdsWithLevels.set(fbeValue.SymbolIdsWithLevels)
    this.SymbolNamesWithLevels.set(fbeValue.SymbolNamesWithLevels)
  }
}

export { FieldModelFeedSubscribeRequest };

/**
 * Fast Binary Encoding FeedSubscribeRequest model
 */
class FeedSubscribeRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelFeedSubscribeRequest(this.buffer, 4)
  }

  /**
   * Get the FeedSubscribeRequest model
   * @this {!FeedSubscribeRequestModel}
   * @returns {!FieldModelFeedSubscribeRequest} model FeedSubscribeRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!FeedSubscribeRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!FeedSubscribeRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return FeedSubscribeRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!FeedSubscribeRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelFeedSubscribeRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!FeedSubscribeRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!FeedSubscribeRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!FeedSubscribeRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!FeedSubscribeRequestModel}
   * @param {!FeedSubscribeRequest} value FeedSubscribeRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!FeedSubscribeRequestModel}
   * @param {!FeedSubscribeRequest} value FeedSubscribeRequest value, defaults is new FeedSubscribeRequest()
   * @return {!object} Deserialized FeedSubscribeRequest value and its size
   */
  deserialize (value = new FeedSubscribeRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new FeedSubscribeRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new FeedSubscribeRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!FeedSubscribeRequestModel}
   * @param {!number} prev Previous FeedSubscribeRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { FeedSubscribeRequestModel };
FeedSubscribeRequest.__has_response = true;
FeedSubscribeRequest.__response_class = FeedSubscribeResponse;
